import React, { useContext } from "react";
import Layout from "../../Data/Layout";
import ElementLayoutCard from "./ElementLayoutCard";
import ElementList from "../../Data/ElementList";
import { ScreenSizeContext } from "../../context/ScreenSizeContext";

function ElementsSidebar() {
  const { dragElementLayout, setDragElementLayout } =
    useContext(ScreenSizeContext);

  // function onDragLayoutStart(layout) {
  //   setDragElementLayout({
  //     dragLayout: {
  //       ...layout,
  //       id: Date.now(),
  //     },
  //   });
  // }

  // function onDragElementStart(element) {
  //   setDragElementLayout({
  //     dragElement: {
  //       ...element,
  //       id: Date.now(),
  //     },
  //   });
  // }

  function onDragLayoutStart(layout) {
    setDragElementLayout({
      dragLayout: {
        ...JSON.parse(JSON.stringify(layout)), // ✅ Deep copy
        id: Date.now(),
      },
    });
  }

  function onDragElementStart(element) {
    setDragElementLayout({
      dragElement: {
        ...JSON.parse(JSON.stringify(element)), // ✅ Deep copy
        id: Date.now(),
      },
    });
  }

  return (
    <div className="bg-gradient-to-b from-blue-100 to-white border-r border-purple-100 h-[90vh] shadow-sm overflow-y-auto">
      {/* Layouts Section */}
      <div className="p-5">
        <div className="flex items-center gap-2 mb-4">
          <div className="w-1 h-6 bg-gradient-to-b from-indigo-600 to-purple-600 rounded-full"></div>
          <h2 className="font-bold text-lg text-gray-800">Layouts</h2>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
          {Layout.map((layout, index) => (
            <div
              key={index}
              draggable
              onDragStart={() => onDragLayoutStart(layout)}
            >
              <ElementLayoutCard layout={layout} index={index} />
            </div>
          ))}
        </div>
      </div>

      {/* Elements Section */}
      <div className="p-5 pt-0">
        <div className="flex items-center gap-2 mb-4 mt-6">
          <div className="w-1 h-6 bg-gradient-to-b from-pink-600 to-purple-600 rounded-full"></div>
          <h2 className="font-bold text-lg text-gray-800">Elements</h2>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
          {ElementList.map((element, index) => (
            <div
              key={index}
              draggable
              onDragStart={() => onDragElementStart(element)}
            >
              <ElementLayoutCard layout={element} index={index} />
            </div>
          ))}
        </div>
      </div>
    </div>
  );

  // return (
  //     <div className="p-5 h-[90vh] shadow-sm overflow-y-auto">
  //         <h2 className="font-bold text-lg">Layouts</h2>
  //         <div className="grid grid-cols-1 md:grid-cols-2 gap-5 mt-3">
  //             {
  //                 Layout.map((layout, index)=>(
  //                     <div key={index} draggable onDragStart={() => onDragLayoutStart(layout)}>
  //                     <ElementLayoutCard layout={layout} index={index}/>
  //                     </div>
  //                 ))
  //             }
  //         </div>

  //         <h2 className="font-bold text-lg mt-6">Elements</h2>
  //         <div className="grid grid-cols-1 md:grid-cols-2 gap-5 mt-3">
  //             {ElementList.map((element, index) => (
  //                 <div key={index} draggable onDragStart={() => onDragElementStart(element)}>
  //                     <ElementLayoutCard layout={element} index={index}/>
  //                 </div>
  //             ))}
  //         </div>
  //     </div>
  // )
}

export default ElementsSidebar;
